__webpack_require__.p = "https://static.assist-ai.happyfox.co/admin/";